import React, {useCallback, useEffect, useState} from 'react';
import {Box,  Typography} from "@material-ui/core";
import {Line} from "react-chartjs-2";
import DateHelper from "../../../helper/DateHelper";
import MeasureService from "../../../services/MeasureService";

const MeasureTestLineChart = (props) => {
  const [bands, setBands] = useState([])
  const [bands1, setBands1] = useState([])

  const fetch = useCallback(async (filterTypes) => {

    const months = DateHelper.getMonthsWithLabel(6)
    const start = months[0].dateMonth
    const end = months[months.length - 1].dateMonth

    const logs = await MeasureService.getMeasureLogChart(start, end, filterTypes.map(p => p.programID), props.measureType)

    // 전체 주차 생성 함수 (MeasureTestDefault.js와 동일한 방식)
    const generateAllWeeks = (startMonth, endMonth) => {
      const allWeeks = [];
      const startMoment = require('moment-timezone')(startMonth, 'YYYY-MM');
      const endMoment = require('moment-timezone')(endMonth, 'YYYY-MM');
      let currentMoment = startMoment.clone();

      while (currentMoment.isSameOrBefore(endMoment, 'month')) {
        const year = currentMoment.year();
        const month = currentMoment.month() + 1;

        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);

        // 해당 월의 1일이 속한 주의 일요일 찾기
        let currentDate = new Date(firstDay);
        const firstDayOfWeek = firstDay.getDay(); // 0: 일요일, 6: 토요일
        currentDate.setDate(1 - firstDayOfWeek); // 해당 주의 일요일로 이동

        let weekOfMonth = 1;

        // 해당 월의 모든 주차 추가
        while (currentDate <= lastDay) {
          // 현재 주가 해당 월에 하루라도 포함되는지 확인
          const weekEndDate = new Date(currentDate);
          weekEndDate.setDate(weekEndDate.getDate() + 6); // 토요일

          // 주의 시작일 또는 종료일이 해당 월에 속하는 경우
          if ((currentDate.getMonth() === month - 1 && currentDate.getDate() <= lastDay.getDate()) ||
              (weekEndDate.getMonth() === month - 1)) {
            const yearMonth = `${year}-${('00' + month).substr(-2)}`;
            allWeeks.push({
              month: yearMonth,
              week: `${weekOfMonth}주`,
              score: null,
              level: null,
              mode: null
            });
            weekOfMonth++;
          }

          // 다음 주로 이동
          currentDate.setDate(currentDate.getDate() + 7);
        }

        currentMoment.add(1, 'month');
      }

      return allWeeks;
    };

    // API 데이터와 전체 주차 병합
    const mergeScoresWithAllWeeks = (scores) => {
      const allWeeks = generateAllWeeks(start, end);

      // API 데이터로 Map 생성 (빠른 조회를 위해)
      const scoreMap = {};
      (scores || []).forEach(score => {
        const key = `${score.month}-${score.week}`;
        scoreMap[key] = score;
      });

      // 전체 주차에 데이터 병합
      return allWeeks.map(week => {
        const key = `${week.month}-${week.week}`;
        return scoreMap[key] || week;
      });
    };

    // measureType이 'train'이면 scores와 scores1로 분리
    if (props.measureType === 'train' && logs.scores1) {
      setBands(mergeScoresWithAllWeeks(logs.scores))
      setBands1(mergeScoresWithAllWeeks(logs.scores1))
    } else {
      setBands(mergeScoresWithAllWeeks(logs.scores || logs))
      setBands1([])
    }
  }, [props.measureType])

  useEffect(() => {
    if(1 === props.currentFilter.length){
      fetch(props.currentFilter).then()
    }
  }, [fetch, props.currentFilter])


  const showChart = props.currentFilter.length === 1
  const hasTwoCharts = props.measureType === 'train' && bands1.length > 0

  return (
    <Box pl={3} pr={3}>
      <Box style={{padding:10}}>
        {showChart &&
          <Typography style={{fontSize: '0.9rem'}}>최근 6개월
            <b style={{fontSize:'1.1rem', paddingLeft: 10}}>{props.currentFilter[0].name}</b> 그래프
          </Typography>
        }
      </Box>

      {hasTwoCharts ? (
        <>
          <Box mb={2}>
            <Typography style={{fontSize: '0.9rem', fontWeight: 'bold', marginBottom: 10, paddingLeft: 10}}>
              훈련
            </Typography>
            <MeasureLineChart
              bands={bands}
              showChart={showChart}
              color="train"
            />
          </Box>
          <Box>
            <Typography style={{fontSize: '0.9rem', fontWeight: 'bold', marginBottom: 10, paddingLeft: 10}}>
              두뇌계발
            </Typography>
            <MeasureLineChart
              bands={bands1}
              showChart={showChart}
              color="challenge"
            />
          </Box>
        </>
      ) : (
        <MeasureLineChart
          bands={bands}
          showChart={showChart}
        />
      )}
    </Box>
  )
};
export function MeasureLineChart(props) {
  let bands = props.bands || []

  const [showChart, setShowCart] = useState(props.showChart)

  // 색상 설정 (train: 핑크, challenge: 초록, 기본: 파랑)
  const getChartColors = () => {
    if (props.color === 'train') {
      return {
        backgroundColor: "rgba(255,105,180,0.2)",
        borderColor: "rgba(255,105,180,0.5)",
        pointBorderColor: "rgba(255,105,180,1)"
      }
    } else if (props.color === 'challenge') {
      return {
        backgroundColor: "rgba(36,124,64,0.2)",
        borderColor: "rgba(36,124,64,0.5)",
        pointBorderColor: "rgba(36,124,64,1)"
      }
    } else {
      return {
        backgroundColor: "rgba(0,178,245,0.2)",
        borderColor: "rgba(0,178,245,0.5)",
        pointBorderColor: "rgba(0,178,245,1)"
      }
    }
  }

  const colors = getChartColors()

  // bands 배열에서 라벨과 값 추출
  const labels = bands.length > 0 ? bands.map(item => {
    const monthNum = item.month.split('-')[1]
    return `${parseInt(monthNum)}월 ${item.week}`
  }) : []

  const values = bands.length > 0 ? bands.map(item => item.score !== null ? item.score : 0) : []

  const data = {
    labels: labels,
    datasets: [
      {
        label: '점수',
        data: values,
        fill: true,
        backgroundColor: colors.backgroundColor,
        borderColor: colors.borderColor,
        pointBorderColor: colors.pointBorderColor,
        pointBackgroundColor: 'white',
        pointBorderWidth: 2,
        pointRadius: 5,
        lineTension: 0, // 직선으로 변경
      }
    ]
  }

  const options = {
    legend: {
      display: false,
      labels: {
        // fontColor: "white",
        // fontSize: 18
      }
    },
    tooltips: {
      enabled: false
    },
    layout: {
      padding: {
        top: 35,
        left: 5,
        right: 5,
        bottom: 5
      }
    },
    animation: {
      onComplete: function() {
        const chartInstance = this.chart;
        const ctx = chartInstance.ctx;

        ctx.font = 'bold 12px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';

        this.data.datasets.forEach((dataset, i) => {
          const meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach((bar, index) => {
            const score = dataset.data[index];
            const item = bands[index];

            // 원본 데이터의 score가 null이 아닐 때만 라벨 표시
            if (item && item.score !== null && item.score !== undefined) {
              // level이 있으면 두 줄로 표시
              if (item.level !== null && item.level !== undefined) {
                // train 모드일 때 level - 1 처리
                let displayLevel = item.level;
                if (item.mode === 'train') {
                  displayLevel = item.level - 1;
                }

                // 첫 번째 줄: Lv.N (회색)
                ctx.fillStyle = '#666';
                ctx.fillText(`Lv.${displayLevel}`, bar._model.x, bar._model.y - 17);
                // 두 번째 줄: score (검정)
                ctx.fillStyle = '#000';
                ctx.fillText(item.score, bar._model.x, bar._model.y - 5);
              } else {
                // level이 없으면 한 줄로 표시 (검정)
                ctx.fillStyle = '#000';
                ctx.fillText(item.score, bar._model.x, bar._model.y - 10);
              }
            }
          });
        });
      }
    },
    scales: {
      xAxes: [{
        display: true,
        gridLines: {
          display: true,
          // color: "#4476C4",
        },
        scaleLabel: {
          display: false,
          labelString: 'Month'
        },
        ticks: {
          // fontColor: "white",
          // fontSize: 18
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45
        },
      }],
      yAxes: [{
        display: true,
        gridLines: {
          display: true,
          // color: "#4476C4"
        },
        scaleLabel: {
          display: false,
          labelString: 'Value'
        },
        ticks: {
          // fontColor: "white",
          suggestedMin: 0,
          suggestedMax: 100,
          beginAtZero: true,
          stepSize: 20,
          // fontSize: 18
        },
      }]
    }
  }

  useEffect(() => {
    setShowCart(props.showChart)
  }, [props.showChart])
  
  return (
    <Box position={'relative'} style={{marginBottom: 20}}>
      <Box 
          position={'absolute'} 
          top={0} 
          left={0} 
          width={'100%'} 
          height={'100%'} 
          style={{
            backgroundColor:'#efefef', 
            border:"2px solid #efefef",
            borderRadius: 10,
            opacity: !showChart ? 1 : 0,
            transitionDuration: 0.3
          }}>
          <div style={{
            textAlign: 'center',
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: '100%'
          }}>
            <div>
              <img src={require(`@images/lineIcon.png`)} style={{height: 80}} alt={'line icon'}/>
            </div>
            프로그램을 선택하면 지난 결과 그래프를 확인 할 수 있습니다.
          </div>
      </Box>
      <Line data={data} options={options} height={50}/>
    </Box>
  )
}

export default MeasureTestLineChart